import { render } from "./SuccessMsg.vue?vue&type=template&id=4e63081a&scoped=true"
import script from "./SuccessMsg.vue?vue&type=script&lang=js"
export * from "./SuccessMsg.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ct-dev/clickcease/google-health-report-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e63081a"]])

export default __exports__